module.exports = "<div class=\"l-wrap\" id=\"i_wrap\" ng-csp>\r\n  <div *ngIf=\"visible\" class=\"l-header\" id=\"i_header\">\r\n    <app-header></app-header>\r\n  </div>\r\n  <div class=\"l-wrap__inner-app\" id=\"l-wrap__inner-app\" [style.minHeight]=\"getHeight()\">\r\n    <div *ngIf=\"visible\" class=\"l-wrap__column -is-left-app\" style=\"background-color:#40516d\" id=\"left_menu_wrap\">\r\n      <app-left></app-left>\r\n    </div>\r\n    <div style=\"width:100%\">\r\n      <router-outlet></router-outlet>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main